import {
  AttributeDefinition,
  AttributeDefinitionValue,
  AttributeOptions,
} from '@dispatch/shared/types';

export const useGetCompanyAttributeOptions = (
  companyAttributes: AttributeDefinition[]
) => {
  const attributesWithId = (values: AttributeDefinitionValue[]) => {
    return values.map((definitionValue: AttributeDefinitionValue) => {
      return {
        value: String(definitionValue.integrationGUID),
        title: definitionValue.displayName,
        definitionValue,
      };
    });
  };

  const attributeDefinitionValues = (values: AttributeDefinitionValue[]) => {
    return values.map((definitionValue: AttributeDefinitionValue) => {
      return {
        value: definitionValue.displayName,
        title: definitionValue.displayName,
        definitionValue,
      };
    });
  };

  const options: AttributeOptions[] | undefined = companyAttributes?.flatMap(
    (definition: AttributeDefinition) => {
      if (!definition || !definition?.isActive) return [];
      const type: 'multi-select' | 'bool' =
        definition?.attributeDefinitionValues?.length > 0
          ? 'multi-select'
          : 'bool';
      return {
        value: definition?.displayName,
        title: definition?.displayName,
        valueType: type,
        attributeDefinitionValues: attributeDefinitionValues(
          definition?.attributeDefinitionValues ?? []
        ),
        definition,
      };
    }
  );

  const optionsWithIds: AttributeOptions[] | undefined =
    companyAttributes?.flatMap((definition: AttributeDefinition) => {
      if (!definition || !definition?.isActive) return [];
      const type: 'multi-select' | 'bool' =
        definition?.attributeDefinitionValues?.length > 0
          ? 'multi-select'
          : 'bool';
      return {
        value: String(definition?.integrationGUID),
        title: definition?.displayName,
        valueType: type,
        attributeDefinitionValues: attributesWithId(
          definition?.attributeDefinitionValues ?? []
        ),
        definition,
      };
    });

  return {
    companyAttributes: options,
    optionsWithIds,
  };
};
